// @flow weak
import z from 'app/common/z';
import _ from 'lodash';
import 'app/legacy/lib/storage';

export const getKeyInStorage = key => {
  try {
    return z.store.get(key);
  } catch (e) {
    return undefined;
  }
};

export const hasKeyInStorage = key => {
  const storageKey = getKeyInStorage(key);
  return !_.isUndefined(storageKey) && !_.isNull(storageKey);
};

export const setKeyInStorage = (key, value) => {
  try {
    return z.store.set(key, value);
  } catch (e) {
    return undefined;
  }
};

export const clearItemsInStorage = z.store.clear;
